import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import {
    CheckSharp,
    ClearSharp,
    FindReplaceSharp,
    UploadSharp,
} from "@mui/icons-material";
import isValidate from "../../utils/validation";

const FileTable = ({
    files,
    onDelete,
    handleEditFiles,
    acceptType,
    isAttachedFiles,
}) => {
    return (
        <TableContainer
            component={Paper}
            sx={{ maxWidth: "50%", mb: 2, mx: "auto" }}
        >
            <Table size="small">
                <TableHead>
                    <TableRow sx={{ bgcolor: "black" }}>
                        <TableCell sx={{ color: "white" }}>Valid</TableCell>

                        <TableCell sx={{ color: "white" }}>File Name</TableCell>
                        {/* <TableCell sx={{ color: "white" }}>Type</TableCell> */}
                        <TableCell align="right" sx={{ color: "white" }}>
                            Size (KB)
                        </TableCell>
                        <TableCell align="right" sx={{ color: "white" }}>
                            Actions
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {files.map((file, index) => (
                        <TableRow key={index}>
                            {isAttachedFiles && (
                                <TableCell>
                                    {isValidate(
                                        "AttachedfileSize",
                                        (file.size / 1024).toFixed(1)
                                    ) ? (
                                        <CheckSharp
                                            fontSize="small"
                                            color="success"
                                        />
                                    ) : (
                                        <ClearSharp
                                            fontSize="small"
                                            color="error"
                                        />
                                    )}
                                </TableCell>
                            )}
                            {!isAttachedFiles && (
                                <TableCell>
                                    {isValidate(
                                        "fileSize",
                                        (file.size / 1024).toFixed(1)
                                    ) ? (
                                        <CheckSharp
                                            fontSize="small"
                                            color="success"
                                        />
                                    ) : (
                                        <ClearSharp
                                            fontSize="small"
                                            color="error"
                                        />
                                    )}
                                </TableCell>
                            )}

                            <TableCell>{`${file.name.slice(0, 25)} ${
                                file.name.length > 25 ? "..." : ""
                            }`}</TableCell>
                            {/* <TableCell>{file.type}</TableCell> */}
                            <TableCell align="right">
                                {(file.size / 1024).toFixed(1)}
                            </TableCell>
                            <TableCell align="right">
                                <IconButton
                                    onClick={() => onDelete(index)}
                                    size="small"
                                >
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                                <IconButton align="right" component="label">
                                    <FindReplaceSharp fontSize="small" />
                                    <input
                                        hidden
                                        type="file"
                                        accept={acceptType}
                                        onChange={(e) =>
                                            handleEditFiles(e, index)
                                        }
                                    />
                                </IconButton>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default FileTable;
